var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardsSuccess = function SvgCardsSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 92,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cardsSuccess_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cardsSuccess_svg__b)",
    d: "m83.378 61.11-69.79-9.807a3.587 3.587 0 0 1-3.053-4.052L16.32 6.088a3.587 3.587 0 0 1 4.052-3.053l69.79 9.809a3.587 3.587 0 0 1 3.052 4.051l-5.785 41.163a3.587 3.587 0 0 1-4.051 3.053"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cardsSuccess_svg__c)",
    d: "m83.378 61.11-69.79-9.807a3.587 3.587 0 0 1-3.053-4.052L16.32 6.088a3.587 3.587 0 0 1 4.052-3.053l69.79 9.809a3.587 3.587 0 0 1 3.052 4.051l-5.785 41.163a3.587 3.587 0 0 1-4.051 3.053"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cardsSuccess_svg__d)",
    d: "M14.27 20.68a1.103 1.103 0 0 0 .938 1.246l74.709 10.5a1.103 1.103 0 0 0 1.246-.94l1.383-9.842a1.103 1.103 0 0 0-.939-1.247L16.9 9.897a1.104 1.104 0 0 0-1.246.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m46.649 31.734-25.69-3.611a1.094 1.094 0 0 1 .305-2.167l25.69 3.61a1.094 1.094 0 1 1-.305 2.168"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cardsSuccess_svg__e)",
    d: "m82.681 36.798-6.912-.972a1.094 1.094 0 1 1 .305-2.167l6.912.972a1.094 1.094 0 1 1-.305 2.167"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cardsSuccess_svg__f)",
    d: "M32.872 37.676 20.38 35.92a1.605 1.605 0 0 1-1.366-1.812l.307-2.185a1.605 1.605 0 0 1 1.812-1.366l12.494 1.756c.878.123 1.49.935 1.366 1.812l-.307 2.185a1.605 1.605 0 0 1-1.813 1.366"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cardsSuccess_svg__g)",
    d: "M32.872 37.676 20.38 35.92a1.605 1.605 0 0 1-1.366-1.812l.307-2.185a1.605 1.605 0 0 1 1.812-1.366l12.494 1.756c.878.123 1.49.935 1.366 1.812l-.307 2.185a1.605 1.605 0 0 1-1.813 1.366"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.872 37.676 20.38 35.92a1.605 1.605 0 0 1-1.366-1.812l.307-2.185a1.605 1.605 0 0 1 1.812-1.366l12.494 1.756c.878.123 1.49.935 1.366 1.812l-.307 2.185a1.605 1.605 0 0 1-1.813 1.366"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cardsSuccess_svg__h)",
    d: "M101.159 67.39 33.085 85.63a3.587 3.587 0 0 1-4.393-2.536L17.933 42.942a3.587 3.587 0 0 1 2.537-4.393l68.074-18.24a3.587 3.587 0 0 1 4.393 2.536l10.758 40.152a3.587 3.587 0 0 1-2.536 4.393"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cardsSuccess_svg__i)",
    d: "m59.936 72.151-25.059 6.715a1.094 1.094 0 0 1-.566-2.114l25.059-6.714a1.094 1.094 0 0 1 .566 2.113"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cardsSuccess_svg__j)",
    d: "m42.881 54.93-10.49 2.81a3.573 3.573 0 0 1-4.376-2.525l-1.602-5.979a3.573 3.573 0 0 1 2.526-4.376l10.49-2.81a3.573 3.573 0 0 1 4.376 2.526l1.602 5.978a3.573 3.573 0 0 1-2.526 4.376"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cardsSuccess_svg__k)",
    d: "m42.881 54.93-10.49 2.81a3.573 3.573 0 0 1-4.376-2.525l-1.602-5.979a3.573 3.573 0 0 1 2.526-4.376l10.49-2.81a3.573 3.573 0 0 1 4.376 2.526l1.602 5.978a3.573 3.573 0 0 1-2.526 4.376"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cardsSuccess_svg__l)",
    d: "m51.406 64.454-19.03 5.099a1.083 1.083 0 0 1-1.326-.766l-.513-1.916a1.083 1.083 0 0 1 .766-1.326l19.03-5.099a1.083 1.083 0 0 1 1.325.766l.514 1.916a1.083 1.083 0 0 1-.766 1.326"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cardsSuccess_svg__m)",
    d: "m78.815 57.045-23.33 6.315a1.083 1.083 0 0 1-1.326-.766l-.513-1.915a1.083 1.083 0 0 1 .766-1.327l23.33-6.315a1.083 1.083 0 0 1 1.326.766l.513 1.916a1.083 1.083 0 0 1-.766 1.326"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cardsSuccess_svg__n)",
    d: "m74.249 37.015-3.16.847a1.083 1.083 0 0 1-1.326-.765l-.514-1.916a1.083 1.083 0 0 1 .766-1.326l3.16-.847a1.083 1.083 0 0 1 1.326.765l.513 1.916a1.083 1.083 0 0 1-.765 1.326"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cardsSuccess_svg__o)",
    d: "m87.843 33.373-9.515 2.55a1.083 1.083 0 0 1-1.326-.766l-.513-1.916a1.083 1.083 0 0 1 .765-1.326l9.515-2.55a1.083 1.083 0 0 1 1.326.766l.514 1.916a1.083 1.083 0 0 1-.766 1.326"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "cardsSuccess_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(134.277 32.846 18.222)scale(53.318 63.7474)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375FA1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cardsSuccess_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(162.787 39.295 11.627)scale(72.3261 35.7107)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD9A58"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cardsSuccess_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-72.62405 59.16954 -53.88944 -66.1433 97.275 24.439)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BED7FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cardsSuccess_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(154.504 18.357 41.3)scale(13.5789 12.6195)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cardsSuccess_svg__k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(138.551 13.132 29.476)scale(22.5658 19.5572)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8D6A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE9348"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cardsSuccess_svg__l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-9.76517 6.02732 -6.44378 -10.4399 45.8 61.108)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cardsSuccess_svg__m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(149.74 28.698 36.622)scale(13.5454 14.1028)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cardsSuccess_svg__n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.62665 3.23578 -3.7873 -3.07435 73.328 33.346)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cardsSuccess_svg__o",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-5.48523 4.35362 -5.07092 -6.38897 85.046 29.833)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cardsSuccess_svg__b",
    x1: 37.97,
    x2: 61.426,
    y1: 0.691,
    y2: 53.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cardsSuccess_svg__e",
    x1: 77.857,
    x2: 80.189,
    y1: 26.072,
    y2: 40.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cardsSuccess_svg__f",
    x1: 26.945,
    x2: 27.069,
    y1: 30.596,
    y2: 37.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cardsSuccess_svg__g",
    x1: 26.887,
    x2: 27.372,
    y1: 34.947,
    y2: 31.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cardsSuccess_svg__j",
    x1: 32.246,
    x2: 40.245,
    y1: 44.924,
    y2: 55.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cardsSuccess_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h46c25.405 0 46 20.595 46 46s-20.595 46-46 46H.5z"
  })))));
};
export default SvgCardsSuccess;